import { ChangeDetectorRef, Component, Input, NgZone, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ADDITIONAL_DETAILS } from "@common/constants";
import { EPreloginServiceCode, IResultNavigationDetails } from "@common/models";
import { ResultService } from "@common/services";
import { BaseFpxFormComponent } from "@common/utils";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subscription, timer } from "rxjs";
import { CommonService } from "src/app/common.service";
import { OtpInputComponent } from "src/app/common/components/otp-input/otp-input.component";
import { InfoPopupComponent } from "src/app/core/components/popup/info-popup/info-popup.component";
import { PinInputComponent } from "src/app/dashboard/pin-input/pin-input.component";
import { RetailStock } from "src/app/retail-common.service";
import { ServiceStock } from "src/app/service-stock.service";
import { PreLoginResultService } from "../pre-login-result-page/services/pre-login-result-page.service";
import { PreLoginService } from "../pre-login.service";
import { OtpPageHelper, OtpPageState } from "./services/otp-page.helper";
import { ILoginauthPayLoad } from "../Pre-login.model";
import { NativeStorageService } from "src/app/services/mobile/native-storage.service";
import { Device } from "@ionic-native/device/ngx";
import { MobileService } from "src/app/mobile.services";
declare let cordova: any;
@Component({
  selector: "app-otp-page",
  templateUrl: "./otp-page.component.html",
  styleUrls: ["./otp-page.component.scss"],
  providers: [
    OtpPageHelper
  ]
})
export class OtpPageComponent extends BaseFpxFormComponent<OtpPageHelper, OtpPageState>{
  data: any
  isHybrid: boolean = false;
  constructor(
    public _preLoginResultService: PreLoginResultService,
    _formBuilder: FormBuilder,
    private _router: Router,
    private _otpPageHelper: OtpPageHelper,
    private _commonService: CommonService,
    private _preloginService: PreLoginService,
    private translate: TranslateService,
    private _resultService: ResultService,
    private dialogRef: MatDialogRef<InfoPopupComponent>,
    private ngZone: NgZone,
    private _nativeStorageService: NativeStorageService,
    public device: Device,
    private mobileService: MobileService,) {
    super(_formBuilder, _router, _otpPageHelper);
    this.isHybrid = this.mobileService.isHybrid();
  }

  initializeForm() {
    
    this.addFormControl("otpChannelOption", "", [], [], 'change');
    this.addFormControl("otpInput", "", [], [], 'change');
  }

  protected doPreInit(): void {
    this.initializeForm();
    this._commonService.hideSpinner();
    // this.state.isOtpChannel = this.getRoutingParam('isotpChannel');
    this.state.isOtpChannel = true;
    this.state.additionalDetails = this.getRoutingParam(ADDITIONAL_DETAILS);
    if (this.data?.screenData) {
      document.body.classList.add('app-otp-popup');
      this._preloginService.setFlow(this.data.screenData.flow);
      this.state.additionalDetails = this.data.screenData;
    }
    this.initializeForm();
    this._otpPageHelper.setNxtAndBackNav();

    if(this.state.isOtpChannel){

    }else{
      this._otpPageHelper.timer(this.state.expireSec);
    }

    // this.timerOn = true;
    if (this._commonService.isDesktop()) {
      if (this._preloginService.getFlow() == 'selfRegister') {
        this._preloginService.showMainHeader = true;
        this._preloginService.selfRegisterHeader = "Verify It's you";
      }
    }
  }

  protected override doPostInit() {
    if(this.state.isOtpChannel){
      var that = this;
      if (this.isHybrid && this.device.platform.toLowerCase() == "android") {
        cordova.plugins.SMSRetriever.startWatch(
          function (strSuccess) {
            console.log(strSuccess);

            document.addEventListener("onSMSArrive", function (message: any) {
              console.log("otp success " + message.message);
              const otp = message.message.substring(0, 6);
              that.formGroup.controls["otpInput"].setValue(otp, {
                eventEmit: true,
              });
              that.stopWatch();
            });
          },
          function (strError) {
            console.warn(strError);
          }
        );
      }
      if(this._preloginService.getUserTwoFactor()?.whatsapp){
        this.formGroup.controls['otpChannelOption'].setValue('5',{eventEmit:true});
      }else{
        this.formGroup.controls['otpChannelOption'].setValue('1',{eventEmit:true});
      }
    }else{
      this.otpFormGroupChange();
    }
  }
    
  stopWatch() {
    cordova.plugins.SMSRetriever.stopWatch(
      function (strSuccess) {
        console.log(strSuccess);
      },
      function (strError) {
        console.warn(strError);
  }
    );
  }

  otpFormGroupChange(){
    this.formGroup.valueChanges.subscribe((currentValue) => {
      this.state.isError = false;
      if (this.state.otpVerify != true) {
        if (currentValue.otpInput.length == 6) {
          this.state.buttonEnable = true;
        } else {
          this.state.buttonEnable = false;
        }
      }

    });
  }

  onClickBackBtn() {
    if (this._preloginService.getFlow() == 'selfRegister') this._preloginService.updateProgessTab('identifyYourself');
    if (this._preloginService.getFlow() == 'postLogin') {
      this.dialogRef.close();
      return;
    }
    this._otpPageHelper.onClickBackBtn()
  }

  onClickResendBtn() {
    this.state.isError = false;
    this._otpPageHelper.doResendOtp('',
      (res) => {
        this.formGroup.controls['otpInput'].reset('');
        this._otpPageHelper.startTimer();
      },
      (err) => {
        this.formGroup.controls['otpInput'].reset('');
        this.navigateToResultPage(this._resultService.resultPageData);
        this._otpPageHelper.resetScreenData();
      });
  }

  override doSubmit(formGroup: FormGroup) {
    if (formGroup.value?.otpInput && (formGroup.value.otpInput == '' || !formGroup.value.otpInput || formGroup.value.otpInput == null)) {
      return;
    }

    this._otpPageHelper.doSubmit(formGroup, formGroup.value.otpInput,
      (res) => {
        let username = sessionStorage.getItem("username");
        let serviceName=this.state?.additionalDetails?.serviceName;
        if (this._preloginService.getFlow() == 'reactivateUser') {
          this.navigateToResultPage(this._resultService.resultPageData);
          this._otpPageHelper.resetScreenData();
          return
        }
         if (this._commonService.isHybrid() && serviceName!="FORGETPASSWORD" && serviceName!="SELFREG" && serviceName!="FORGOTUSERNAME" && serviceName!="UNLOCKUSER") {
          const payload: ILoginauthPayLoad = {
            username: username,
            loginauth: '',
            remDevice: '',
            deviceId: '',
            password: ''
          }
          this._preloginService.checkmpinregistered(payload).subscribe({
            next: (response: any) => {
              let deviceRegistered = response.body?.deviceRegistered;
              let userRegistered = response.body?.userRegistered;
              let authDevice = response.body?.authDevice;

              if (deviceRegistered == "false" && userRegistered == "false") {
                console.log("Create mpin false false");
                this._preloginService.setPrimaryUser(username);
                this.ngZone.run(() => {
                  this._router.navigate(['login', 'setMPIN']);
                  });
              }
              else if (deviceRegistered == "true" && userRegistered == "true") {

                this._preloginService.setPrimaryUser(username);
                if (sessionStorage.getItem('OTHEROPTIONLOGIN') == 'true') {
                  sessionStorage.removeItem('OTHEROPTIONLOGIN');
                  this._preloginService.doWelcome();
                } else {
                  this.ngZone.run(() => {
                    this._router.navigate(['login', 'mpin-login']);
                    });
                }

              }
              else if (deviceRegistered == "false" && userRegistered == "true") {
                //if (this.state.registeredUser && this.state.registeredUser != sessionStorage.getItem("username")) {
                 // this._preloginService.doWelcome();
               // } else {
                  this._commonService.hideSpinner();
                  //this._preloginService.showAlert('mpin', 'MPIN', 'Proceeding further in the current device will de-register the existing device.', ['close', 'confirm'], 'confirmation');
                  this.ngZone.run(() => {
                    this._router.navigate(['login', 'setMPIN']);
                    });
                //}
              }
              else if (deviceRegistered == "true" && userRegistered == "false") {
                //console.log("Create mpin true false");
                //this._nativeStorageService.retriveData("registeredUser").then((value) => {
                 //   this._preloginService.doWelcome();
                //}).catch(error => {
                    
                    this.ngZone.run(() => {
                        this._router.navigate(['login', 'setMPIN']);
                        });
                //});
              }
            }
          })
        }

      },
      (err) => {
        this._commonService.hideSpinner();
        this.navigateToResultPage(this._resultService.resultPageData);
        this._otpPageHelper.resetScreenData();
      });
  }

  ngOnDestroy(): void {
    delete this._preloginService?.twoFactor;
    document.body.classList.remove('app-otp-popup');
  }


  submitChannel(){
    this._commonService.showSpinner();
    this._otpPageHelper.submitChannel(this.formGroup.controls['otpChannelOption'].value).subscribe(
      async (res) => {
        if(this.formGroup.controls['otpChannelOption'].value=='1'){
          delete this._preloginService?.twoFactor?.mobile;
          this.state.mobileNum = undefined;
          this.state.whatsapp = undefined;

        }else if(this.formGroup.controls['otpChannelOption'].value=='2'){
          delete this._preloginService?.twoFactor?.email;
          this.state.emailId = undefined;
          this.state.whatsapp = undefined;
        }
        else if(this.formGroup.controls['otpChannelOption'].value=='5'){
          delete this._preloginService?.twoFactor?.email;
          this.state.emailId = undefined;
          this.state.mobileNum = undefined;
        }
        this._commonService.hideSpinner();
        this.state.isOtpChannel = false;
        this.otpFormGroupChange();
        this._otpPageHelper.timer(this.state.expireSec);

      },
      (err) => {
        this._commonService.hideSpinner();
        // if(this.formGroup.controls['otpChannelOption'].value=='1'){
        //   delete this._preloginService?.twoFactor?.mobile;
        //   this.state.mobileNum = undefined;
        // }else if(this.formGroup.controls['otpChannelOption'].value=='2'){
        //   delete this._preloginService?.twoFactor?.email;
        //   this.state.emailId = undefined;
        // }
        // this._commonService.hideSpinner();
        // this.state.isOtpChannel = false;
        // this.otpFormGroupChange();
        // this._otpPageHelper.timer(120);
      });
  }                   

}
